import Vue from 'vue'
import { Button, Table, Col, Form, Input, Select, DatePicker, Row, LocaleProvider, message, Modal } from 'ant-design-vue'
import './index.less'

Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(LocaleProvider)
Vue.use(Button)
Vue.use(Table)
Vue.use(Row)
Vue.use(Col)
Vue.use(Form)
Vue.use(Input)
Vue.use(Select)
Vue.use(DatePicker)

Vue.prototype.$message = message
Vue.prototype.$confirm = Modal.confirm
